import Vue from "vue";
import router from "@/router";
import store from "@/store";
import i18n from "@/locales";
import { getHost } from "@/helpers/url";

function checkResponse(commit, response) {
  // eslint-disable-next-line
  //console.log("Response", response);

  if (response.headers["scgi_status"] === "0") {
    // eslint-disable-next-line
    //console.log("Result:", response.data);

    return "ok";
  } else {
    // eslint-disable-next-line
    //console.error("Error:", response.data.error);

    let result;
    const classError = response.data.error.class;
    const codeError = response.data.error.code;
    const msgError = response.data.error.msg;
    const msgOrigError = response.data.error.msg_orig || "";
    const msgStackError = response.data.error.stack || "";

    if (classError === "auth") {
      if (codeError === 100) {
        result = i18n.t("common.errors.usernameNotFoundInDatabase") + "~~~~";
      } else if (codeError === 101) {
        result = i18n.t("common.errors.usernameOrPasswordNotFound") + "~~~~";
      } else if (codeError === 102) {
        result = i18n.t("common.errors.accessDenied") + "~~~~";
      } else if (codeError === 103) {
        result = i18n.t("common.errors.invalidUsernameOrPassword") + "~~~~";
      } else if (codeError === 104) {
        result = i18n.t("common.errors.accountExpired") + "~~~~";
      } else if (
        codeError === 1 ||
        codeError === 2 ||
        codeError === 3 ||
        codeError === 10
      ) {
        result = i18n.t("common.errors.sessionExpired") + "~~~~";
        commit("setError", result);
        clearSession();
      } else {
        result = `${msgError}~~${msgOrigError}~~${msgStackError}`;
      }
    } else {
      result = `${msgError}~~${msgOrigError}~~${msgStackError}`;
    }
    return result;
  }
}

function clearSession() {
  store.commit("setUser", {
    login: null,
    language: null,
    token: null,
    tokenid: null,
    userid: null
  });
  store.commit("setBase", {
    url: null,
    label: null
  });
  store.commit("setAuthUrl", null);
  store.commit("setAuthServers", null);
  store.commit("setAuthSections", null);
  store.commit("setAuthBases", null);

  Vue.localStorage.remove("wb-auth");

  store.getters.externalAuth
    ? (window.location.href = `${getHost()}signout/`)
    : router.push("/signin");
  // router.push("/signin");
}

export { checkResponse, clearSession };
